import { defineStore } from 'pinia';
import { inject, ref } from 'vue';
import { i18nInjectionKey } from '@/utils/keys';

const useAppStore = defineStore('app', () => {
  const i18n = inject(i18nInjectionKey);

  const setWindowTitle = (title?: string) => {
    if (typeof document === 'undefined') {
      return;
    }

    const websiteTitle = i18n?.global.t('common.websiteTitle.default') ?? '';

    document.title = (title ? `${title} - ` : '') + websiteTitle;
  }

  const sidebarOpen = ref(false);
  const toggleSidebar = () => { sidebarOpen.value = !sidebarOpen.value; };
  const closeSidebar = () => { sidebarOpen.value = false; };

  return {
    setWindowTitle,
    sidebarOpen,
    toggleSidebar,
    closeSidebar,
  };
});

export default useAppStore;
